import React from 'react'
import Axios from 'axios'
import Availabilities from '../Availabilities'
import PhotoUpload from '../AddTeacherModal/PhotoUpload/PhotoUpload'
import './admin-teacher-modal.css'
import NewLoadingScreen from '../NewLoadingScreen/NewLoadingScreen'
import { baseUrl } from '../assets/Animations'
import AreYouSureDeleteTeacherModal from './AreYouSureDeleteTeacherModal/AreYouSureDeleteTeacherModal'
import EditTeacherAvailabilityPopup from './EditTeacherAvailabilityPopup/EditTeacherAvailabilityPopup'
import AddInstrumentPopup from '../AddTeacherModal/AddInstrumentsPopup/AddInstrumentsPopup'
import AddTownsPopup from '../AddTeacherModal/AddTownsPopup/AddTownsPopup'
import { MdExpandMore } from 'react-icons/md'
import CreateFeedbackLinkModal from './CreateFeedbackLinkModal/CreateFeedbackLinkModal'
import {
    APIProvider,
    AdvancedMarker,
    InfoWindow,
    Map as GoogleMap,
    Pin,
} from '@vis.gl/react-google-maps';
import { MdAccessibility } from 'react-icons/md';
import axios from 'axios'
import WarningPopup from '../DanitComponents/Modals/WarningPopup/WarningPopup'
import {
    buildLegacyTeacherWaitlistDriveMinutes,
    buildTeacherWaitlistRows,
    findCachedTeacherWaitlistDriveMinutes,
    findTeacherWaitlistDirectoryKey,
    formatTeacherWaitlistAddress,
    getTeacherWaitlistResponseRows,
    sortTeacherWaitlistRowsByDriveTime,
    TEACHER_WAITLIST_DRIVE_BUCKET,
} from './adminTeacherWaitlistUtils'
import TeacherNotificationTestButton from './TeacherNotificationTestButton/TeacherNotificationTestButton'
import { normalizeTeacherName } from '../teacherNameUtils'

const DEFAULT_MAP_CENTER = { lat: 40.0150, lng: -105.2705 }

const AdminTeacherModal = (props) => {
    const [photoChange, setPhotoChange] = React.useState(false)
    const [imageName, setImageName] = React.useState('')
    const [changes, setChanges] = React.useState(false)
    const [name, setName] = React.useState(props.teacher.Name)
    const [instruments, setInstruments] = React.useState(props.teacher.Instrument)
    const [calendarId, setCalendarId] = React.useState(props.teacher.CalendarID)
    const [email, setEmail] = React.useState(props.teacher.Email)
    const [phone, setPhone] = React.useState(props.teacher.PhoneNumber)
    const [street, setStreet] = React.useState(props.teacher.Address.StreetAddress)
    const [city, setCity] = React.useState(props.teacher.Address.City)
    const [state, setAddressState] = React.useState(props.teacher.Address.State)
    const [zip, setZip] = React.useState(props.teacher.Address.Zip)
    const [bio, setBio] = React.useState(props.teacher.Bio)
    const [rate, setRate] = React.useState(props.teacher.Rate)
    const [teachAvail, setTeachAvail] = React.useState(props.teacher.AvailabilityDetails)
    const [seoContent, setSeoContent] = React.useState(props.teacher.SEOContent)
    const [teacherStatus, setTeacherStatus] = React.useState('')
    const [isAdmin, setIsAdmin] = React.useState(false)
    const [permissionLevel, setPermissionLevel] = React.useState('')
    const [adminNotes, setAdminNotes] = React.useState('')
    const [bkgd, setBkgd] = React.useState(props.teacher.BackgroundCheck)
    const [verifiedColor, setVerifiedColor] = React.useState('rgb(182, 118, 0)')
    const [activeStudents, setActiveStudents] = React.useState(0)
    const [facebook, setFacebook] = React.useState('')
    const [twitter, setTwitter] = React.useState('')
    const [instagram, setInstagram] = React.useState('')
    const [youtube, setYoutube] = React.useState('')
    const [linkedin, setLinkedin] = React.useState('')
    const [pinterest, setPinterest] = React.useState('')
    const [soundcloud, setSoundcloud] = React.useState('')
    const [tumblr, setTumblr] = React.useState('')
    const [tiktok, setTiktok] = React.useState('')
    const [personalWebsite, setPersonalWebsite] = React.useState('')
    const [deleteModal, setDeleteModal] = React.useState(false)
    const [loading, setLoading] = React.useState(false)
    const [wantsMore, setWantsMore] = React.useState(props.teacher.WantsMoreStudents)
    const [editTeacherAvailability, setEditTeacherAvailability] = React.useState(false)
    const [instPopup, setInstPopup] = React.useState(false)
    const [townsPopup, setTownsPopup] = React.useState(false)
    const [listOfInstruments, setListOfInstruments] = React.useState([])
    const [listOfTowns, setListOfTowns] = React.useState([])
    const [listOfCancellations, setListOfCancellations] = React.useState([])
    const [listOfTimesheets, setListOfTimesheets] = React.useState([])
    const [tab, setTab] = React.useState('profile')
    const [onboardDate, setOnboardDate] = React.useState('')
    const [departureDate, setDepartureDate] = React.useState('')
    const [calendarColor, setCalendarColor] = React.useState({})
    const [potentialWaitlistStudents, setPotentialWaitlistStudents] = React.useState([])
    const [loadingPotentialWaitlist, setLoadingPotentialWaitlist] = React.useState(false)
    const [potentialWaitlistError, setPotentialWaitlistError] = React.useState('')
    const [loadingWaitlistDriveTimes, setLoadingWaitlistDriveTimes] = React.useState(false)
    const [waitlistDriveTimeError, setWaitlistDriveTimeError] = React.useState('')
    const [teacherFeedback, setTeacherFeedback] = React.useState([])
    const [openFeedbackCard, setOpenFeedbackCard] = React.useState(false)
    const [createFeedbackLinkModal, setCreateFeedbackLinkModal] = React.useState(false)
    const [showMarkerName, setShowMarkerName] = React.useState(false)
    const [deleteGeoLocations, setDeleteGeoLocations] = React.useState([])
    const [teachersLatLong, setTeachersLatLong] = React.useState(null)
    const [leavingTeacherWarningModal, setLeavingTeacherWarningModal] = React.useState(false)

    const myToken = localStorage.getItem('token')
    const myHeader = {
        headers: { Authorization: `Bearer ${myToken}` }
    }

    const stars = Array.from({ length: 5 }, (_, index) => index + 1);

    const normalizeStudentRoster = React.useMemo(() => {
        const rawStudents = Array.isArray(props.teacher?.newStudentList) ? props.teacher.newStudentList : []
        const detailedStudents = Array.isArray(props.teacher?.Students) ? props.teacher.Students : []

        const detailedStudentMap = new window.Map()
        detailedStudents.forEach((student) => {
            const possibleNames = [
                student?.studentName,
                student?.StudentName,
                student?.firstName,
                student?.name,
            ].filter(Boolean)

            possibleNames.forEach((possibleName) => {
                detailedStudentMap.set(String(possibleName).trim().toLowerCase(), student)
            })

            if (student?.studentId) {
                detailedStudentMap.set(`id:${String(student.studentId)}`, student)
            }
        })

        return rawStudents.map((student, index) => {
            const candidateStudentName =
                student?.studentName ||
                student?.StudentName ||
                student?.firstName ||
                student?.name ||
                ''
            const candidateFamilyName =
                student?.familyName ||
                student?.FamilyName ||
                student?.lastName ||
                ''

            const detailedStudent =
                (student?.studentId && detailedStudentMap.get(`id:${String(student.studentId)}`)) ||
                detailedStudentMap.get(String(candidateStudentName || '').trim().toLowerCase()) ||
                null

            const firstName = String(candidateStudentName || '').trim().split(' ')[0] || 'Unnamed'

            const rawInstrumentList = Array.isArray(student?.instrumentList)
                ? student.instrumentList
                : Array.isArray(student?.InstrumentList)
                    ? student.InstrumentList
                    : Array.isArray(student?.instruments)
                        ? student.instruments
                        : Array.isArray(detailedStudent?.instrumentList)
                            ? detailedStudent.instrumentList
                            : Array.isArray(detailedStudent?.InstrumentList)
                                ? detailedStudent.InstrumentList
                                : Array.isArray(detailedStudent?.instruments)
                                    ? detailedStudent.instruments
                                    : student?.instrument
                                        ? [student.instrument]
                                        : student?.Instrument
                                            ? [student.Instrument]
                                            : detailedStudent?.instrument
                                                ? [detailedStudent.instrument]
                                                : detailedStudent?.Instrument
                                                    ? [detailedStudent.Instrument]
                                                    : []

            const instruments = rawInstrumentList
                .map((inst) => {
                    if (typeof inst === 'string') return inst
                    return inst?.name || inst?.Name || inst?.parentInstrument || ''
                })
                .filter(Boolean)

            return {
                key: student?.studentId || `${student?.familyId || 'family'}-${candidateStudentName || index}`,
                familyId: student?.familyId || detailedStudent?.familyId || '',
                studentId: student?.studentId || '',
                studentName: firstName,
                familyName: String(candidateFamilyName || detailedStudent?.familyName || '').trim(),
                lessonLength:
                    student?.lessonLength ||
                    student?.Length ||
                    detailedStudent?.lessonLength ||
                    detailedStudent?.Length ||
                    '',
                instruments,
            }
        })
    }, [props.teacher?.Students, props.teacher?.newStudentList])

    React.useEffect(() => {
        if(props.teacher) {
            getTeachersCancellations()
        }
        if(props.teacher.AdminNotes) {
            setAdminNotes(props.teacher.AdminNotes)
        }
        if(props.teacher.InstrumentList) {
            setListOfInstruments(props.teacher.InstrumentList)
        }
        if(props.teacher.ImageName) {
            setImageName(props.teacher.ImageName)  
        }
        if(props.teacher.TownList) {
            setListOfTowns(props.teacher.TownList)
        }
        if(props.teacher.SocialLinks) {
            setFacebook(props.teacher.SocialLinks.Facebook)
            setTwitter(props.teacher.SocialLinks.Twitter)
            setInstagram(props.teacher.SocialLinks.Instagram)
            setYoutube(props.teacher.SocialLinks.Youtube)
            setLinkedin(props.teacher.SocialLinks.Linkedin)
            setPinterest(props.teacher.SocialLinks.Pinterest)
            setSoundcloud(props.teacher.SocialLinks.Soundcloud)
            setTumblr(props.teacher.SocialLinks.Tumblr)
            setTiktok(props.teacher.SocialLinks.Tiktok)
            setPersonalWebsite(props.teacher.SocialLinks.Website)
        }
        if(props.teacher.OnboardDate) {
            setOnboardDate(props.teacher.OnboardDate)
        }
        if(props.teacher.DepartureDate) {
            setDepartureDate(props.teacher.DepartureDate)
        }
        if(props.teacher.CalendarColor) {
            setCalendarColor(props.teacher.CalendarColor)
        }
        if(props.teacher.BackgroundCheck === 'verified') {
            setBkgd('verified')
            setVerifiedColor('green')
        } else if (props.teacher.BackgroundCheck === 'pending') {
            setBkgd('pending')
            setVerifiedColor('rgb(182, 118, 0)')
        } else if (props.teacher.BackgroundCheck === 'ordered'){
            setBkgd('ordered')
            setVerifiedColor('rgb(182, 118, 0)')
        } else {
            setBkgd('pending')
            setVerifiedColor('rgb(182, 118, 0)')
        }
        setActiveStudents(tallyActiveStudents())
        if(props.teacher.Status) {
            setTeacherStatus(props.teacher.Status)
        } else {
            setTeacherStatus('Active')
        }
        openingAnimation()
        getTeachersLatLong()
    }, [])

    React.useEffect(() => {
        if(tab === 'waitlist') {
            generateAllWaitlistFamilies()
        }
        if(tab === 'feedback') {
            getTeachersFeeback()
        }
    }, [tab])

    React.useEffect(() => {
        document.getElementById('the-verfied-selector').value = bkgd
        if(bkgd === 'verified') {
            setVerifiedColor('green')
        } else {
            setVerifiedColor('rgb(182, 118, 0)')
        }
    }, [bkgd])
    React.useEffect(() => {
        if(instPopup) {
            setChanges(true)
        }
        if(townsPopup) {
            setChanges(true)
        }
    }, [instPopup, townsPopup])

    const openingAnimation = () => {
        document.getElementById('admin-teacher-modal').style.left = "50px"
        document.getElementById('admin-teacher-modal').style.opacity = 1
        document.getElementById("admin-teacher-modal-wrapper").style.opacity = 1
    }

    const closingAnimation = () => {
        document.getElementById('admin-teacher-modal').style.left = "-1000px"
        document.getElementById('admin-teacher-modal').style.opacity = 0 
        document.getElementById("admin-teacher-modal-wrapper").style.opacity = 0
    }

    const getTeachersFeeback = () => {
        Axios.get(`${baseUrl}/teacherfeedback/${props.teacher.TeacherID}`, myHeader)
        .then((res) => {
            setTeacherFeedback(res.data)
        })
        .catch((err) => {
            console.log(err)
        })
    }

    const getTeachersCancellations = () => {
        Axios.get(`${baseUrl}/oldtimesheets/${props.teacher.TeacherID}`, myHeader)
        .then((res) => {
            setListOfTimesheets(res.data)
            let list = []
            for(let i = 0; i < res.data.length; i++) {
                let cancellationTotal = 0
                for(let j = 0; j < res.data[i].families.length; j++) {
                    for(let k = 0; k < res.data[i].families[j].cancellations.length; k++) {
                        if(res.data[i].families[j].cancellations[k].cancellor === 'teacher') {
                            cancellationTotal++
                        }
                    }
                }
                if (cancellationTotal > 0) {
                    list.push({
                        timesheetId: res.data[i].timesheetId,
                        timesheetDate: res.data[i].monthYear,
                        total: cancellationTotal,
                    })
                }
            }
            setListOfCancellations(list)
        })
        .catch((err) => {

        })
    }

    const toggleUploadModal = () => {
        setPhotoChange(!photoChange)
    }
    const tallyActiveStudents = () => {
        const teacherStudents = Array.isArray(props.teacher?.Students) ? props.teacher.Students : []
        let count = 0
        for(let i = 0; i < teacherStudents.length; i++) {
            if(teacherStudents[i].Active) {
                count = count + 1
            }
        }
        return count
    }

    const setTeacherToLeaving = (value, stateFunction) => {
        Axios.post(`${baseUrl}/sendteacherleavingslack`, {
            school: props.teacher.School,
            message: `:rotating_light: ${props.teacher.Name} has left ${props.teacher.School.toUpperCase()}! :rotating_light:`
        }, myHeader)
        stateFunction(value)
        setChanges(true)
        setLeavingTeacherWarningModal(false)
    }

    const changeTeacherInfo = (value, stateFunction) => {
        if(value === "Left School") {
            setLeavingTeacherWarningModal({
                type: 'warning',
                title: `You are attempting to change ${props.teacher.Name} to "Left School".`,
                message: `Please confirm that this teacher has submitted their last timesheet and their calendar has been cleared first. (If not, please select "Leaving" instead)`,
                onConfirm: {
                    text: 'Set to Left School',
                    action: () => setTeacherToLeaving("Left School", setTeacherStatus)
                },
                onCancel: {
                    text: 'Cancel',
                    action: () => setLeavingTeacherWarningModal(false)
                }
            })
            return
        }
        if(value === "leaving") {
            Axios.post(`${baseUrl}/sendteacherleavingslack`, {
                school: props.teacher.School,
                message: `:rotating_light: ${props.teacher.Name} is leaving ${props.teacher.School.toUpperCase()}! :rotating_light:`
            }, myHeader)
        }
        stateFunction(value)
        setChanges(true)
    }
    // const changeBackground = (value, stateFunction) => {
    //     changeTeacherInfo(value, stateFunction)
    //     setChanges(true)
    //    //props.changeBackgroundCheck(value)
    // }

    const clickOut = (e) => {
        if(e.target.id === "admin-teacher-modal-wrapper" || e.target.id === 'admin-modal-x') {
            if(changes) {
                setLoading(true)
                Axios.put(`${baseUrl}/updateteacherinfo`, {
                    Name: normalizeTeacherName(name),
                    TeacherID: props.teacher.TeacherID,
                    Password: props.teacher.Password,
                    Instrument: instruments,
                    InstrumentList: listOfInstruments,
                    SEOContent: seoContent,
                    TownList: listOfTowns,
                    CalendarID: calendarId,
                    Email: email.toLowerCase(),
                    ImageName: imageName,
                    PhoneNumber: phone,
                    StreetAddress: street,
                    City: city,
                    State: state,
                    Zip: zip,
                    Bio: bio,
                    Rate: rate,
                    AdminNotes: adminNotes,
                    BackgroundCheck: bkgd,
                    Status: teacherStatus,
                    IsAdmin: isAdmin,
                    PermissionLevel: permissionLevel,
                    Facebook: facebook,
                    Twitter: twitter,
                    Instagram: instagram,
                    Youtube: youtube,
                    Linkedin: linkedin,
                    Pinterest: pinterest,
                    Soundcloud: soundcloud,
                    Tumblr: tumblr,
                    Tiktok: tiktok,
                    Website: personalWebsite,
                    WantsMoreStudents: wantsMore,
                    OnboardDate: onboardDate,
                    DepartureDate: departureDate,
                    CalendarColor: calendarColor
                }, myHeader)
                .then(response => {
                    if(response.status === 200) {
                        setLoading(false)
                        closingAnimation()
                        setTimeout(() => {
                            props.closeModal(response.data)
                        }, 400)
                    } else {
                        alert('There was an error! Please write to Prescott...')
                    }
                })
                .catch(e => {
                    alert(e)
                })
            } else {
                closingAnimation()
                setTimeout(() => {
                    props.closeModal(props.teacher) 
                }, 400)
            }
        } else {
            return
        }
    }

    const openStudentProfile = (familyId) => {
        if (!familyId) return
        if (typeof props.setStudentModal2023 === 'function') {
            props.setStudentModal2023(familyId)
            return
        }
        if (typeof props.getFamilyData === 'function') {
            props.getFamilyData(familyId)
        }
    }

    const registerChange = () => {
        setChanges(true)
    }

    const deleteTheTeacher = (theTeacherId) => {
        Axios.delete(`${baseUrl}/data/${theTeacherId}`, myHeader)
        .then(res => {
            if(res.status == 201) {
                props.removeDeletedTeacher(res.data.TeacherID)
                setDeleteModal(false)
                props.closeModal()
            }
        })
        .catch((err) => {
            console.log(err)
        })
    }

    const openThisTimesheet = (id) => {
        for(let i = 0; i < listOfTimesheets.length; i++) {
            if(listOfTimesheets[i].timesheetId === id) {
                props.setOpenTimesheet(listOfTimesheets[i])
            }
        }
    }

    const generateWebsiteLink = async () => {
        if(props.teacher.School === 'mma') {
              await navigator.clipboard.writeText(`https://www.mountainsidemusicacademy.com/music-teachers/lessons-with-${props.teacher.Name.replace(/ /g,'-').toLowerCase()}`);
              alert(`Copied ${props.teacher.Name.split(' ')[0]}'s Website Link`);
        } else if (props.teacher.School === 'lsma') {
              await navigator.clipboard.writeText(`https://www.lakesidemusicacademy.com/instructors/lessons-with-${props.teacher.Name.replace(/ /g,'-').toLowerCase()}`);
              alert(`Copied ${props.teacher.Name.split(' ')[0]}'s Website Link`);
        } else if (props.teacher.School === 'tma') {
              await navigator.clipboard.writeText(`https://www.treesidemusicacademy.com/instructors/lessons-with-${props.teacher.Name.replace(/ /g,'-').toLowerCase()}`);
              alert(`Copied ${props.teacher.Name.split(' ')[0]}'s Website Link`);
        } else if (props.teacher.School === 'mor') {
              await navigator.clipboard.writeText(`https://www.morningsidemusicacademy.com/instructors/lessons-with-${props.teacher.Name.replace(/ /g,'-').toLowerCase()}`);
              alert(`Copied ${props.teacher.Name.split(' ')[0]}'s Website Link`);
        } else if (props.teacher.School === 'psma') {
              await navigator.clipboard.writeText(`https://www.parksidemusicacademy.com/instructors/lessons-with-${props.teacher.Name.replace(/ /g,'-').toLowerCase()}`);
              alert(`Copied ${props.teacher.Name.split(' ')[0]}'s Website Link`);
        } else if (props.teacher.School === 'tem') {
            await navigator.clipboard.writeText(`https://www.atharomusic.com/tempe-music-academy/instructors/lessons-with-${props.teacher.Name.replace(/ /g,'-').toLowerCase()}`);
            alert(`Copied ${props.teacher.Name.split(' ')[0]}'s Website Link`);
        } else if (props.teacher.School === 'den') {
            await navigator.clipboard.writeText(`https://www.atharomusic.com/denton-music-academy/instructors/lessons-with-${props.teacher.Name.replace(/ /g,'-').toLowerCase()}`);
            alert(`Copied ${props.teacher.Name.split(' ')[0]}'s Website Link`);
        } else if (props.teacher.School === 'tul') {
            await navigator.clipboard.writeText(`https://www.atharomusic.com/tulsa-music-academy/instructors/lessons-with-${props.teacher.Name.replace(/ /g,'-').toLowerCase()}`);
            alert(`Copied ${props.teacher.Name.split(' ')[0]}'s Website Link`);
        }
    }

    const generateAllWaitlistFamilies = async () => {
        setLoadingPotentialWaitlist(true)
        setPotentialWaitlistError('')
        setWaitlistDriveTimeError('')

        try {
            const school = encodeURIComponent(String(props.teacher.School || '').toUpperCase())
            const response = await Axios.get(
                `${baseUrl}/school-management/school/${school}`,
                myHeader
            )
            const waitlistRows = buildTeacherWaitlistRows({
                families: response.data,
                teacherInstruments: props.teacher.InstrumentList,
            }).map((student) => ({
                ...student,
                driveTimeMinutes: null,
                driveTimeStatus: student.familyAddress ? 'Loading…' : 'Address missing',
            }))
            setPotentialWaitlistStudents(waitlistRows)
            setLoadingPotentialWaitlist(false)
            await loadTeacherWaitlistDriveTimes(waitlistRows)
        } catch (err) {
            console.error('Unable to load the teacher waitlist:', err)
            setPotentialWaitlistStudents([])
            setPotentialWaitlistError('The waitlist could not be loaded. Please try again.')
        } finally {
            setLoadingPotentialWaitlist(false)
        }
    }

    const loadTeacherWaitlistDriveTimes = async (waitlistRows) => {
        if (!Array.isArray(waitlistRows) || waitlistRows.length === 0) return

        const schoolId = String(props.teacher.School || '').trim().toLowerCase()
        const teacherId = String(
            props.teacher.TeacherID || props.teacher.teacherId || props.teacher.teacherID || ''
        ).trim()
        const teacherAddress = formatTeacherWaitlistAddress(
            props.teacher.Address || props.teacher.address || {}
        )
        if (!schoolId || !teacherId) {
            setPotentialWaitlistStudents((current) => current.map((student) => ({
                ...student,
                driveTimeStatus: 'Unavailable',
            })))
            return
        }

        const uniqueFamilies = new Map()
        waitlistRows.forEach((student) => {
            if (student.familyId && !uniqueFamilies.has(student.familyId)) {
                uniqueFamilies.set(student.familyId, student)
            }
        })
        const loadLegacyDriveMinutes = async () => {
            const response = await Axios.get(
                `${baseUrl}/new-teacher-email/${encodeURIComponent(teacherId)}/school/${encodeURIComponent(schoolId)}?includeAll=true`,
                myHeader
            )
            return buildLegacyTeacherWaitlistDriveMinutes(response?.data)
        }
        const persistLegacyDriveMinutes = async (minutesByFamily) => {
            const edges = Array.from(minutesByFamily.entries()).flatMap(([familyId, minutes]) => {
                const family = uniqueFamilies.get(familyId)
                if (!family?.familyAddress || !Number.isFinite(minutes)) return []
                return [{
                    fromKey: `teacher:${teacherId}`,
                    toKey: `family:${familyId}`,
                    minutes,
                    teacherId,
                    familyId,
                    originAddress: teacherAddress,
                    destinationAddress: family.familyAddress,
                    originLabel: props.teacher.Name || teacherId,
                    destinationLabel: family.familyName || family.studentName || familyId,
                }]
            })
            if (!teacherAddress || edges.length === 0) return

            try {
                const response = await Axios.post(
                    `${baseUrl}/drive-edges/import`,
                    {
                        schoolId,
                        bucket: TEACHER_WAITLIST_DRIVE_BUCKET,
                        todBucket: TEACHER_WAITLIST_DRIVE_BUCKET,
                        edges,
                    },
                    myHeader
                )
                if ((response?.data?.skipped || []).length > 0) {
                    console.warn('Some fallback waitlist drive times could not be cached:', response.data.skipped)
                }
            } catch (persistError) {
                console.error('Unable to cache fallback waitlist drive times:', persistError)
            }
        }
        const applyDriveMinutes = (minutesByFamily) => {
            setPotentialWaitlistStudents((current) => sortTeacherWaitlistRowsByDriveTime(
                current.map((student) => {
                    const minutes = minutesByFamily.get(student.familyId)
                    return {
                        ...student,
                        driveTimeMinutes: Number.isFinite(minutes) ? minutes : null,
                        driveTimeStatus: Number.isFinite(minutes)
                            ? ''
                            : student.familyAddress
                                ? 'Could not calculate'
                                : 'Address missing',
                    }
                })
            ))
        }
        const getUnresolvedCount = (minutesByFamily) => Array.from(uniqueFamilies.keys()).filter(
            (familyId) => !Number.isFinite(minutesByFamily.get(familyId))
        ).length

        setLoadingWaitlistDriveTimes(true)
        setWaitlistDriveTimeError('')
        try {
            const [directoryResponse, edgeResponse] = await Promise.all([
                Axios.get(`${baseUrl}/place-directory/${encodeURIComponent(schoolId)}`, myHeader),
                Axios.get(`${baseUrl}/drive-edges/${encodeURIComponent(schoolId)}`, myHeader),
            ])
            let directories = getTeacherWaitlistResponseRows(directoryResponse, 'directories')
            const cachedEdges = getTeacherWaitlistResponseRows(edgeResponse, 'edges')
            let hadPartialDriveTimeError = false
            const teacherFallbackKey = `teacher:${teacherId}`
            let teacherPlaceKey = findTeacherWaitlistDirectoryKey({
                directories,
                entityType: 'teacher',
                entityId: teacherId,
                fallbackKey: teacherFallbackKey,
            })

            const familyPlaceKeys = new Map()
            const missingDirectories = []
            if (!teacherPlaceKey && teacherAddress) {
                teacherPlaceKey = teacherFallbackKey
                missingDirectories.push({
                    key: teacherPlaceKey,
                    address: teacherAddress,
                    label: props.teacher.Name || teacherId,
                    roles: ['teacher-home'],
                    teacherIds: [teacherId],
                })
            }
            if (!teacherPlaceKey) {
                setPotentialWaitlistStudents((current) => current.map((student) => ({
                    ...student,
                    driveTimeStatus: 'Teacher address missing',
                })))
                return
            }

            uniqueFamilies.forEach((student, familyId) => {
                const fallbackKey = `family:${familyId}`
                let placeKey = findTeacherWaitlistDirectoryKey({
                    directories,
                    entityType: 'family',
                    entityId: familyId,
                    fallbackKey,
                })
                if (!placeKey && student.familyAddress) {
                    placeKey = fallbackKey
                    missingDirectories.push({
                        key: placeKey,
                        address: student.familyAddress,
                        label: student.familyName || student.studentName || familyId,
                        roles: ['family'],
                        familyIds: [familyId],
                    })
                }
                if (placeKey) familyPlaceKeys.set(familyId, placeKey)
            })

            if (missingDirectories.length > 0) {
                try {
                    const bulkResponse = await Axios.post(
                        `${baseUrl}/place-directories/bulk`,
                        { schoolId, directories: missingDirectories },
                        myHeader
                    )
                    if ((bulkResponse?.data?.skipped || []).length > 0) {
                        hadPartialDriveTimeError = true
                    }

                    const refreshedDirectoryResponse = await Axios.get(
                        `${baseUrl}/place-directory/${encodeURIComponent(schoolId)}`,
                        myHeader
                    )
                    const refreshedDirectories = getTeacherWaitlistResponseRows(
                        refreshedDirectoryResponse,
                        'directories'
                    )
                    if (refreshedDirectories.length > 0) {
                        directories = refreshedDirectories
                        teacherPlaceKey = findTeacherWaitlistDirectoryKey({
                            directories,
                            entityType: 'teacher',
                            entityId: teacherId,
                            fallbackKey: teacherFallbackKey,
                        }) || teacherPlaceKey

                        familyPlaceKeys.clear()
                        uniqueFamilies.forEach((student, familyId) => {
                            const placeKey = findTeacherWaitlistDirectoryKey({
                                directories,
                                entityType: 'family',
                                entityId: familyId,
                                fallbackKey: `family:${familyId}`,
                            })
                            if (placeKey) familyPlaceKeys.set(familyId, placeKey)
                        })
                    }
                } catch (error) {
                    hadPartialDriveTimeError = true
                    console.error('Unable to store some waitlist locations:', error)
                }
            }

            const minutesByFamily = new Map()
            const missingPairs = []
            familyPlaceKeys.forEach((toKey, familyId) => {
                const cachedMinutes = findCachedTeacherWaitlistDriveMinutes({
                    edges: cachedEdges,
                    schoolId,
                    fromKey: teacherPlaceKey,
                    toKey,
                    bucket: TEACHER_WAITLIST_DRIVE_BUCKET,
                })
                if (cachedMinutes !== null) {
                    minutesByFamily.set(familyId, cachedMinutes)
                } else {
                    missingPairs.push({ fromKey: teacherPlaceKey, toKey, familyId })
                }
            })

            if (missingPairs.length > 0) {
                try {
                    const driveResponse = await Axios.post(
                        `${baseUrl}/drive-edges/fill`,
                        {
                            schoolId,
                            bucket: TEACHER_WAITLIST_DRIVE_BUCKET,
                            todBucket: TEACHER_WAITLIST_DRIVE_BUCKET,
                            pairs: missingPairs.map(({ fromKey, toKey }) => ({ fromKey, toKey })),
                        },
                        myHeader
                    )
                    let returnedEdges = getTeacherWaitlistResponseRows(driveResponse, 'edges')
                    const refreshedEdgeResponse = await Axios.get(
                        `${baseUrl}/drive-edges/${encodeURIComponent(schoolId)}`,
                        myHeader
                    ).catch(() => null)
                    returnedEdges = [
                        ...returnedEdges,
                        ...getTeacherWaitlistResponseRows(refreshedEdgeResponse, 'edges'),
                    ]
                    missingPairs.forEach(({ familyId, fromKey, toKey }) => {
                        const minutes = findCachedTeacherWaitlistDriveMinutes({
                            edges: returnedEdges,
                            schoolId,
                            fromKey,
                            toKey,
                            bucket: TEACHER_WAITLIST_DRIVE_BUCKET,
                        })
                        if (minutes !== null) minutesByFamily.set(familyId, minutes)
                    })
                } catch (error) {
                    hadPartialDriveTimeError = true
                    console.error('Unable to calculate some waitlist drive times:', error)
                }
            }

            if (getUnresolvedCount(minutesByFamily) > 0) {
                try {
                    const legacyMinutes = await loadLegacyDriveMinutes()
                    const newlyResolvedMinutes = new Map()
                    legacyMinutes.forEach((minutes, familyId) => {
                        if (!Number.isFinite(minutesByFamily.get(familyId))) {
                            minutesByFamily.set(familyId, minutes)
                            newlyResolvedMinutes.set(familyId, minutes)
                        }
                    })
                    await persistLegacyDriveMinutes(newlyResolvedMinutes)
                } catch (legacyError) {
                    hadPartialDriveTimeError = true
                    console.error('Unable to load fallback waitlist drive times:', legacyError)
                }
            }

            applyDriveMinutes(minutesByFamily)
            const unresolvedDriveTimes = getUnresolvedCount(minutesByFamily)
            if (unresolvedDriveTimes > 0) {
                setWaitlistDriveTimeError(
                    `${unresolvedDriveTimes} drive time${unresolvedDriveTimes === 1 ? '' : 's'} could not be calculated. Check the saved addresses, then retry.`
                )
            } else if (!hadPartialDriveTimeError) {
                setWaitlistDriveTimeError('')
            }
        } catch (error) {
            console.error('Unable to load teacher waitlist drive times:', error)
            try {
                const legacyMinutes = await loadLegacyDriveMinutes()
                await persistLegacyDriveMinutes(legacyMinutes)
                applyDriveMinutes(legacyMinutes)
                const unresolvedDriveTimes = getUnresolvedCount(legacyMinutes)
                setWaitlistDriveTimeError(unresolvedDriveTimes > 0
                    ? `${unresolvedDriveTimes} drive time${unresolvedDriveTimes === 1 ? '' : 's'} could not be calculated. Check the saved addresses, then retry.`
                    : '')
            } catch (legacyError) {
                console.error('Unable to load fallback teacher waitlist drive times:', legacyError)
                setWaitlistDriveTimeError('Some drive times could not be loaded. All matching students are still shown.')
                applyDriveMinutes(new Map())
            }
        } finally {
            setLoadingWaitlistDriveTimes(false)
        }
    }

    const createInstArray = (fam) => {
        let instString = []
        for(let i = 0; i < fam.students.length; i++) {
            fam.students.forEach(student => {
              student.instrumentList.forEach(inst => {
                if(instString.includes(inst.name)) {
                  return
                } else {
                  instString.push(inst.name)
                }
              })
            })
        }
        return instString
    }

    const getGeo = React.useCallback(async (fam) => {
        let myAddress = `${replaceSpacesWithPlus(fam.address.addressLine1)},+${fam.address.city},+${fam.address.state}`

        return axios.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${myAddress}&key=AIzaSyDKCEsq1kPacCY7j2S78YOskPLApGtK3jQ`)
        .then((res) => {
            if(res.data.status === 'OK') {
                //create random id, name, and location
                //add to deleteGeoLocations
                let myId = Math.floor(Math.random() * (100000000 - 0 + 1) + 0)
                let myName = fam.lastName
                let myLocation = res.data.results[0].geometry.location
                let myObject = {id: myId, name: myName, students: fam.students.length, address: `${fam.address.addressLine1} ${fam.address.city}`, inst: createInstArray(fam), location: myLocation, home: false}
                return myObject
            }
        })
        .catch((err) => {
            console.log(err)
            return null
        })
    }, [])

    const getTeachersLatLong = React.useCallback(async () => {
        let myAddress = `${replaceSpacesWithPlus(props.teacher.Address.StreetAddress)},+${props.teacher.Address.City},+${props.teacher.Address.State}`
        return axios.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${myAddress}&key=AIzaSyDKCEsq1kPacCY7j2S78YOskPLApGtK3jQ`)
        .then((res) => {
            if(res.data.status === 'OK') {
                //create random id, name, and location
                //add to deleteGeoLocations
                let myId = Math.floor(Math.random() * (100000000 - 0 + 1) + 0)
                let myName = props.teacher.Name
                let myLocation = res.data.results[0].geometry.location
                let myObject = {id: myId, name: myName, location: myLocation, home: true}
                setTeachersLatLong(myLocation)
                return myObject
            }
        })
        .catch((err) => {
            console.log(err)
            return null
        })
    }, [])

    const resetPasswordToPassword = () => {
        Axios.put(`${baseUrl}/emergencypassreset`, {
            Secret: 'dpEWyb',
            Email: email,
        }, myHeader)
        .then((res) => {
            alert(`${res.data.Name}'s password has been reset to password`)
        })
        .catch((err) => {
            alert(err)
        })
    }

    const changeSeoContent = (index, field, value) => {
        setChanges(true)
        if(field === 'structuredData') {
            setSeoContent((prev) => {
                const newContent = [...prev];
                newContent[index].structuredData.offers.url = value.replace(/"/g, '\\"'); // Escape double quotes
                return newContent;
            });
        } else {
            setSeoContent((prev) => {
                const newContent = [...prev];
                newContent[index][field] = value;
                return newContent;
            });
        }
    };
    const addBodyParagraph = (index) => {
        setChanges(true)
        setSeoContent((prev) => {
            const newContent = [...prev];
            newContent[index].bodyText.push({ content: '', id: Math.floor(Math.random() * (100000000 - 0 + 1) + 0) });
            return newContent;
        });
    };
    const changeBodyText = (index, bodyIndex, value) => {
        setChanges(true)
        setSeoContent((prev) => {
            const newContent = [...prev];
            newContent[index].bodyText[bodyIndex].content = value;
            return newContent;
        });
    };

    const checkAllAddresses = React.useCallback(async () => {
        let allGeoLocations = [];
        let studentListWithNoDuplicates = []
        let teachersHome = await getTeachersLatLong();
        const teacherStudents = Array.isArray(props.teacher?.newStudentList) ? props.teacher.newStudentList : []
        if (teachersHome) {
            allGeoLocations.push(teachersHome);
        }
        let familyIdKey={}
        for(let i = 0; i < teacherStudents.length; i++) {
            if(familyIdKey[teacherStudents[i].familyId]) {
                continue
            } else {
                familyIdKey[teacherStudents[i].familyId] = true
                studentListWithNoDuplicates.push(teacherStudents[i])
            }
        }
        for (let i = 0; i < studentListWithNoDuplicates.length; i++) {
            let res = await getGeo(studentListWithNoDuplicates[i]);
            if (res) {
                allGeoLocations.push(res);
            }
        }
        setDeleteGeoLocations(allGeoLocations);
    }, [props.teacher?.newStudentList, getGeo, getTeachersLatLong]);

    React.useEffect(() => {
        const teacherStudents = Array.isArray(props.teacher?.newStudentList) ? props.teacher.newStudentList : []
        if(teacherStudents.length > 0 && tab === 'map') {
            checkAllAddresses()
        }
    }, [props.teacher?.newStudentList, tab, checkAllAddresses])

    const replaceSpacesWithPlus = (string) => {
        let newString = ''
        for(let i = 0; i < string.length; i++) {
            if(string[i] === ' ') {
                newString = newString + '+'
            } else {
                newString = newString + string[i]
            }
        }
        //remove any # from the string
        newString = newString.replace(/#/g, '')
        return newString
    }

    const validGeoLocations = React.useMemo(
        () =>
            Array.isArray(deleteGeoLocations)
                ? deleteGeoLocations.filter(
                    (location) =>
                        location?.location &&
                        Number.isFinite(location.location.lat) &&
                        Number.isFinite(location.location.lng)
                  )
                : [],
        [deleteGeoLocations]
    )

    const mapCenter = React.useMemo(() => {
        if (teachersLatLong && Number.isFinite(teachersLatLong.lat) && Number.isFinite(teachersLatLong.lng)) {
            return teachersLatLong
        }
        if (validGeoLocations.length > 0) {
            return validGeoLocations[0].location
        }
        return DEFAULT_MAP_CENTER
    }, [teachersLatLong, validGeoLocations])

    const CustomMarkers = ({points}) => {
        const validPoints = Array.isArray(points)
            ? points.filter(
                (location) =>
                    location?.location &&
                    Number.isFinite(location.location.lat) &&
                    Number.isFinite(location.location.lng)
              )
            : []

        return (
            <>
                {validPoints.map((location, index) => {
                        return(
                            <AdvancedMarker onClick={() => setShowMarkerName(location.id)} key={location.id} position={location.location}>
                                {showMarkerName === location.id ? 
                                  <div className="test-marker" position={location.location}>
                                    <div className="test-marker__name">{location.name} Family</div>
                                    <div className="test-marker__address">{location.address}</div>
                                    <div className='test-marker__icon-row'>
                                      <div className="test-marker__students">
                                        <MdAccessibility />
                                        <div>{location.students}</div>
                                      </div>
                                      <div className='test-marker__instruments'>
                                        {location.inst?.map((inst, index) => (
                                          <div key={index} className='test-marker__inst'>{inst}</div>
                                        ))}
                                      </div>
                                    </div>
                                    <div className='little-box'></div>
                                  </div>
                                :
                                <div className='test-pin'>
                                <Pin background={location.home ? 'blue' : 'red'} borderColor={location.home ? 'blue' : '#B31413'} glyphColor={location.home ? 'white' : '#B31413'} />
                                </div>
                }
                              
                                {/* <InfoWindow position={location.location}><p>{location.name}</p></InfoWindow>} */}
                            </AdvancedMarker>
                        )
                    })}
            </>
        )
    }

    return(
        <div className="admin-teacher-modal-wrapper" id="admin-teacher-modal-wrapper" onClick={(e) => clickOut(e)}>
            {createFeedbackLinkModal && <CreateFeedbackLinkModal teacher={props.teacher} setCreateFeedbackLinkModal={setCreateFeedbackLinkModal} />}
            {leavingTeacherWarningModal && <WarningPopup warningPopup={leavingTeacherWarningModal} />}
            {deleteModal && <AreYouSureDeleteTeacherModal teacherName={name} teacher={props.teacher} setDeleteModal={setDeleteModal} deleteTheTeacher={deleteTheTeacher} />}
            {loading && <NewLoadingScreen message={'Saving Changes'}/>}
            <PhotoUpload modal={photoChange} setImg={registerChange} setImageName={(name) => setImageName(name)} toggleUploadModal={toggleUploadModal} />
            {instPopup && <AddInstrumentPopup setInstPopup={setInstPopup} listOfInstruments={listOfInstruments} setListOfInstruments={setListOfInstruments} />}
            {townsPopup && <AddTownsPopup setTownsPopup={setTownsPopup} listOfTowns={listOfTowns} setListOfTowns={setListOfTowns} school={props.teacher.School} />}
            {editTeacherAvailability && <EditTeacherAvailabilityPopup teacherAvail={teachAvail} teacherName={props.teacher.Name} email={email} setTeachAvail={setTeachAvail} setEditTeacherAvailability={setEditTeacherAvailability} />}
            <div className="admin-teacher-modal" id="admin-teacher-modal">
                <div className='admin-modal-copy-link-btn' onClick={() => generateWebsiteLink()}><svg version="1.1" id="Layer_1"  x="0px" y="0px"
	 viewBox="0 0 64 64" enable-background="new 0 0 64 64">
<g id="Text-files">
	<path d="M53.9791489,9.1429005H50.010849c-0.0826988,0-0.1562004,0.0283995-0.2331009,0.0469999V5.0228
		C49.7777481,2.253,47.4731483,0,44.6398468,0h-34.422596C7.3839517,0,5.0793519,2.253,5.0793519,5.0228v46.8432999
		c0,2.7697983,2.3045998,5.0228004,5.1378999,5.0228004h6.0367002v2.2678986C16.253952,61.8274002,18.4702511,64,21.1954517,64
		h32.783699c2.7252007,0,4.9414978-2.1725998,4.9414978-4.8432007V13.9861002
		C58.9206467,11.3155003,56.7043495,9.1429005,53.9791489,9.1429005z M7.1110516,51.8661003V5.0228
		c0-1.6487999,1.3938999-2.9909999,3.1062002-2.9909999h34.422596c1.7123032,0,3.1062012,1.3422,3.1062012,2.9909999v46.8432999
		c0,1.6487999-1.393898,2.9911003-3.1062012,2.9911003h-34.422596C8.5049515,54.8572006,7.1110516,53.5149002,7.1110516,51.8661003z
		 M56.8888474,59.1567993c0,1.550602-1.3055,2.8115005-2.9096985,2.8115005h-32.783699
		c-1.6042004,0-2.9097996-1.2608986-2.9097996-2.8115005v-2.2678986h26.3541946
		c2.8333015,0,5.1379013-2.2530022,5.1379013-5.0228004V11.1275997c0.0769005,0.0186005,0.1504021,0.0469999,0.2331009,0.0469999
		h3.9682999c1.6041985,0,2.9096985,1.2609005,2.9096985,2.8115005V59.1567993z"/>
	<path d="M38.6031494,13.2063999H16.253952c-0.5615005,0-1.0159006,0.4542999-1.0159006,1.0158005
		c0,0.5615997,0.4544001,1.0158997,1.0159006,1.0158997h22.3491974c0.5615005,0,1.0158997-0.4542999,1.0158997-1.0158997
		C39.6190491,13.6606998,39.16465,13.2063999,38.6031494,13.2063999z"/>
	<path d="M38.6031494,21.3334007H16.253952c-0.5615005,0-1.0159006,0.4542999-1.0159006,1.0157986
		c0,0.5615005,0.4544001,1.0159016,1.0159006,1.0159016h22.3491974c0.5615005,0,1.0158997-0.454401,1.0158997-1.0159016
		C39.6190491,21.7877007,39.16465,21.3334007,38.6031494,21.3334007z"/>
	<path d="M38.6031494,29.4603004H16.253952c-0.5615005,0-1.0159006,0.4543991-1.0159006,1.0158997
		s0.4544001,1.0158997,1.0159006,1.0158997h22.3491974c0.5615005,0,1.0158997-0.4543991,1.0158997-1.0158997
		S39.16465,29.4603004,38.6031494,29.4603004z"/>
	<path d="M28.4444485,37.5872993H16.253952c-0.5615005,0-1.0159006,0.4543991-1.0159006,1.0158997
		s0.4544001,1.0158997,1.0159006,1.0158997h12.1904964c0.5615025,0,1.0158005-0.4543991,1.0158005-1.0158997
		S29.0059509,37.5872993,28.4444485,37.5872993z"/>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
</div>
                <div className="admin-modal-x" id="admin-modal-x" onClick={(e) => clickOut(e)}>X</div>
                <img className="modal-header" src={`/${props.teacher.School.toUpperCase()}.jpg`} />
                    <div className="background-verified-wrapper">
                    </div>
                <div className='admin-teacher-modal__tab-wrapper'>
                    <div className='admin-teacher-modal__tab' style={tab === 'profile' ? {color: '#000', fontWeight: '900', borderBottom: '3px solid #8EAAAF'} : {color: '#888', fontWeight: '400'}} onClick={() => setTab('profile')}>Profile</div>
                    <div className='admin-teacher-modal__tab' style={tab === 'availability' ? {color: '#000', fontWeight: '900', borderBottom: '3px solid #8EAAAF'} : {color: '#888', fontWeight: '400'}} onClick={() => setTab('availability')}>Availability</div>
                    <div className='admin-teacher-modal__tab' style={tab === 'notes' ? {color: '#000', fontWeight: '900', borderBottom: '3px solid #8EAAAF'} : {color: '#888', fontWeight: '400'}} onClick={() => setTab('notes')}>Notes</div>
                    <div className='admin-teacher-modal__tab' style={tab === 'socials' ? {color: '#000', fontWeight: '900', borderBottom: '3px solid #8EAAAF'} : {color: '#888', fontWeight: '400'}} onClick={() => setTab('socials')}>SEO</div>
                    <div className='admin-teacher-modal__tab' style={tab === 'students' ? {color: '#000', fontWeight: '900', borderBottom: '3px solid #8EAAAF'} : {color: '#888', fontWeight: '400'}} onClick={() => setTab('students')}>Students</div>
                    <div className='admin-teacher-modal__tab' style={tab === 'cancellations' ? {color: '#000', fontWeight: '900', borderBottom: '3px solid #8EAAAF'} : {color: '#888', fontWeight: '400'}} onClick={() => setTab('cancellations')}>Cancellations</div>
                    <div className='admin-teacher-modal__tab' style={tab === 'waitlist' ? {color: '#000', fontWeight: '900', borderBottom: '3px solid #8EAAAF'} : {color: '#888', fontWeight: '400'}} onClick={() => setTab('waitlist')}>Waitlist</div>
                    <div className='admin-teacher-modal__tab' style={tab === 'feedback' ? {color: '#000', fontWeight: '900', borderBottom: '3px solid #8EAAAF'} : {color: '#888', fontWeight: '400'}} onClick={() => setTab('feedback')}>Feedback</div>
                    <div className='admin-teacher-modal__tab' style={tab === 'map' ? {color: '#000', fontWeight: '900', borderBottom: '3px solid #8EAAAF'} : {color: '#888', fontWeight: '400'}} onClick={() => setTab('map')}>Map</div>
                </div>
                <div className="teacher-profile-box">
                    <img className="admin-modal-pic" alt={name} src={`https://app.atharo.app/images/${imageName}`} />
                    <div className="admin-modal-photo-overlay" onClick={() => setPhotoChange(true)}>
                        <h5 className="admin-modal-photo-words">Change Photo</h5>
                    </div>
                    <input className="admin-modal-teacher-name" placeholder="Teacher Name" value={name} onChange={(e) => changeTeacherInfo(e.target.value, setName) } />
                    <div className="admin-modal-teacher-teacherid">{props.teacher.TeacherID}</div>
                    <div className='admin-modal-onboard-date__wrapper'>
                        <input className='admin-modal-teacher-onboarding-date' type='date' value={onboardDate} onChange={(e) => changeTeacherInfo(e.target.value, setOnboardDate)} />
                    </div>
                    <h5 className="admin-teacher-modal__number-of-students">{normalizeStudentRoster.length} Students</h5>
                    <div className='teacher-box__verified-wrapper'>
                        {bkgd === 'verified' && <img className="verified-icon" src="check.svg" />}
                        {bkgd === 'ordered' && <img className="verified-icon ordered-check" src="phone.svg" />}
                        {bkgd === 'pending' && <img className="verified-icon not-verified" src="question.svg" />}
                        <select id="the-verfied-selector" value={bkgd} onChange={(e) => changeTeacherInfo(e.target.value, setBkgd)} className="verified-selector" style={{color: verifiedColor}}>
                            <option value='verified'>Verified</option>
                            <option value='ordered'>Ordered</option>
                            <option value='pending'>Pending</option>
                        </select>
                        <select className="teacher-status-selector" value={teacherStatus} onChange={(e) => changeTeacherInfo(e.target.value, setTeacherStatus)}>
                            <option value="">Select Status</option>
                            <option value="Active">Active</option>
                            <option value="goon">Probation</option>
                            <option value="summer-break">Summer Break</option>
                            <option value="leaving">Leaving</option>
                            <option value="Left School">Left School</option>
                        </select>
                    </div>
                    {teacherStatus === 'leaving' && 
                        <div className='departure-date__wrapper'>
                            <div className='departure-date__label'>Departure Date:</div>
                            <input className='admin-modal-teacher-onboarding-date' type='date' value={departureDate} onChange={(e) => changeTeacherInfo(e.target.value, setDepartureDate)} />
                        </div>
                    }
                    <div className="thin-grey-line"></div>
                    <div className='teacher-box__list-wrapper'>
                        {listOfInstruments.map((inst) => <p className='new-list-of-instruments' key={inst.id}>{inst.name}</p>)}
                    </div>
                    <div className="thin-grey-line"></div>
                    <div className='teacher-box__list-wrapper'>
                        {listOfTowns.map((town) => <p className='new-list-of-towns' key={town.id}>{town.townName}</p>)}
                    </div>
                    {listOfTowns.length > 0 && <div className="thin-grey-line"></div>}
                    <TeacherNotificationTestButton teacher={props.teacher} />
                    <div className='admin-teacher-modal__edits-wrapper'>
                        <div className='admin-teacher-modal__edit-instruments-btn' onClick={() => setInstPopup(true)}>Edit Instruments</div>
                        <div className='admin-teacher-modal__edit-towns-btn' onClick={() => setTownsPopup(true)}>Edit Towns</div>
                    </div>
                </div>
                {tab === 'profile' &&
                    <div className='teacher-modal__new-info-box'>
                        <div className='new-info-box__spacer-div'>
                            <h5 className="for-cal-id-label">Calendar ID:</h5>
                            <input placeholder="" className="for-cal-id" placeholder="Calendar ID" value={calendarId} onChange={(e) => changeTeacherInfo(e.target.value, setCalendarId)} />
                        </div>
                        <h5 className="admin-teacher-info-label">Rate:</h5>
                        <div className="dollar-wrapper">
                            <h5 className="dollar-sign">$</h5>
                            <input className="admin-modal-teacher-rate" placeholder="Rate" value={rate} onChange={(e) => changeTeacherInfo(e.target.value, setRate) } />
                        </div>
                        <h5 className="admin-teacher-info-label">Phone:</h5>
                        <input className="basic-teacher-info-input phone-input" placeholder="Phone Number" value={phone} onChange={(e) => changeTeacherInfo(e.target.value, setPhone)} />
                        <div className='new-info-box__spacer-div'>
                            <h5 className="admin-teacher-info-label">Email:</h5>
                            <input className="basic-teacher-info-input email-input" placeholder="Email" value={email} onChange={(e) => changeTeacherInfo(e.target.value, setEmail)} />
                        </div>
                        <div className="thin-grey-line-"></div>
                        <div className='new-info-box__spacer-div'>
                            <div className="admin-availability-title">Address:</div>
                            <input className="basic-teacher-info-input add-inline for-street" placeholder="Street Address" value={street} onChange={(e) => changeTeacherInfo(e.target.value, setStreet)} />
                            <div>
                                <input className="basic-teacher-info-input add-inline for-city" placeholder="City" value={city} onChange={(e) => changeTeacherInfo(e.target.value, setCity)} />
                                <input className="basic-teacher-info-input add-inline for-state" placeholder="State" value={state} onChange={(e) => changeTeacherInfo(e.target.value, setAddressState)} />
                                <input className="basic-teacher-info-input add-inline for-zip" placeholder="ZIP" value={zip} onChange={(e) => changeTeacherInfo(e.target.value, setZip)} />
                            </div>
                        </div>
                        <h5 className="bio-label">Bio:</h5>
                        <textarea className="for-bio" placeholder="Bio" value={bio} onChange={(e) => changeTeacherInfo(e.target.value, setBio)} />
                    </div>
                }
                {tab === 'availability' &&
                    <div className='teacher-modal__new-info-box'>
                        <div>
                            <div style={wantsMore ? {opacity: 1} : {opacity: 0.2}}>
                                <Availabilities wholeAvail={teachAvail} />
                            </div>
                            <div className='admin-availability__edit-teachers-availability__wrapper'>
                                <div style={wantsMore ? {opacity: 1} : {opacity: 0.2}} className='admin-availability__edit-teachers-availability' onClick={wantsMore ? () => setEditTeacherAvailability(true) : null}>Edit Availability</div>
                                <div className="teacher-modal__full-schedule-switch__wrapper">
                                {!wantsMore && <svg className="new-teacher-portal__switch-svg" viewBox="0 0 511.999 511.999" onClick={() => changeTeacherInfo(true, setWantsMore)}>
                                    <g>
                                    	<g>
                                    		<path fill="rgb(255, 100, 100)" d="M376.499,120.5h-241C60.784,120.5,0,181.286,0,256s60.784,135.5,135.499,135.5h241c74.715,0,135.5-60.785,135.5-135.5
                                    			S451.214,120.5,376.499,120.5z M135.499,361.501C77.326,361.501,30,314.173,30,256c0-58.173,47.326-105.5,105.499-105.5
                                    			c58.173,0,105.5,47.327,105.5,105.5C240.999,314.173,193.672,361.501,135.499,361.501z"/>
                                    	</g>
                                    </g>
                                </svg>}
                                {wantsMore && <svg className="new-teacher-portal__switch-svg" viewBox="0 0 512 512" onClick={() => changeTeacherInfo(false, setWantsMore)}>
                                    <g>
                                    	<g>
                                    		<path fill="rgba(0, 128, 0, 0.8)" d="M376.5,120.5h-241C60.785,120.5,0,181.285,0,256s60.785,135.5,135.5,135.5h241c74.715,0,135.5-60.785,135.5-135.5
                                    			S451.215,120.5,376.5,120.5z M376.5,361.5C318.327,361.5,271,314.174,271,256c0-58.172,47.327-105.5,105.5-105.5
                                    			c58.173,0,105.5,47.328,105.5,105.5C482,314.174,434.673,361.5,376.5,361.5z"/>
                                    	</g>
                                    </g>
                                </svg>}
                                {wantsMore ? <h5>Wants More Students</h5> : <h5>FULL!</h5>}
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {tab === 'notes' &&
                    <div className='teacher-modal__new-info-box'>
                        <div className="teacher-notes"><strong>Teacher's Notes:</strong> {props.teacher.Notes}</div>
                        <h5 className="for-notes-admin-label">Admin Notes (Only Visible to Admins):</h5>
                        <textarea className="for-notes-admin" value={adminNotes} onChange={(e) => changeTeacherInfo(e.target.value, setAdminNotes)} />
                    </div>
                }
                {tab === 'socials' &&
                    <div className='teacher-modal__new-info-box'>
                        {seoContent.map((content, index) => (   
                            <div className='seo-content__wrapper' key={index}>
                                <input className='seo-content__slug' value={content.slug} onChange={(e) => changeSeoContent(index, 'slug', e.target.value)} />
                                <h5 className='seo-content__label'>{content.instrument}</h5>
                                <div>INTRO</div>
                                <div>{content.intro.map((item, idx) => <p key={idx}>{item.content}</p>)}</div>
                                <div>BODY</div>
                                <div>{content.bodyText.map((item, idx) => <textarea className='seo-content__body-text' onChange={(e) => changeBodyText(index, idx, e.target.value)} key={idx} value={item.content} />)}</div>
                                <div className='seo-content__add-body__btn' onClick={() => addBodyParagraph(index)}>Add Body Paragraph</div>
                                <div>FAQ</div>
                                <div>{content.faqs.map((item, idx) => <div key={idx}><p>{item.question}</p>{item.answer}</div>)}</div>
                                <div>STRUCTURED DATA</div>
                                <div>
                                   <input className='seo-content__structured-data' value={content.structuredData.offers.url} onChange={(e) => changeSeoContent(index, 'structuredData', e.target.value)} />
                                </div>
                                
                            </div>
                        ))}

                        <div className="teacher-social-links">
                            <div className='teacher-social-links__wrapper'>
                                <h5 className='teacher-social-links__label'>Facebook</h5>
                                <input className='teacher-social-links__input' value={facebook} placeholder="Teacher's Facebook" onChange={(e) => changeTeacherInfo(e.target.value, setFacebook)}/>
                            </div>
                            <div className='teacher-social-links__wrapper'>
                                <h5 className='teacher-social-links__label'>Twitter</h5>
                                <input className='teacher-social-links__input' value={twitter} placeholder="Teacher's Twitter" onChange={(e) => changeTeacherInfo(e.target.value, setTwitter)}/>
                            </div>
                            <div className='teacher-social-links__wrapper'>
                                <h5 className='teacher-social-links__label'>Instagram</h5>
                                <input className='teacher-social-links__input' value={instagram} placeholder="Teacher's Instagram" onChange={(e) => changeTeacherInfo(e.target.value, setInstagram)}/>
                            </div>
                            <div className='teacher-social-links__wrapper'>
                                <h5 className='teacher-social-links__label'>Youtube</h5>
                                <input className='teacher-social-links__input' value={youtube} placeholder="Teacher's Youtube" onChange={(e) => changeTeacherInfo(e.target.value, setYoutube)}/>
                            </div>
                            <div className='teacher-social-links__wrapper'>
                                <h5 className='teacher-social-links__label'>LinkedIn</h5>
                                <input className='teacher-social-links__input' value={linkedin} placeholder="Teacher's LinkedIn" onChange={(e) => changeTeacherInfo(e.target.value, setLinkedin)}/>
                            </div>
                            <div className='teacher-social-links__wrapper'>
                                <h5 className='teacher-social-links__label'>Pinterest</h5>
                                <input className='teacher-social-links__input' value={pinterest} placeholder="Teacher's Pinterest" onChange={(e) => changeTeacherInfo(e.target.value, setPinterest)}/>
                            </div>
                            <div className='teacher-social-links__wrapper'>
                                <h5 className='teacher-social-links__label'>Soundcloud</h5>
                                <input className='teacher-social-links__input' value={soundcloud} placeholder="Teacher's SoundCloud" onChange={(e) => changeTeacherInfo(e.target.value, setSoundcloud)}/>
                            </div>
                            <div className='teacher-social-links__wrapper'>
                                <h5 className='teacher-social-links__label'>Tumblr</h5>
                                <input className='teacher-social-links__input' value={tumblr} placeholder="Teacher's Tumblr" onChange={(e) => changeTeacherInfo(e.target.value, setTumblr)}/>
                            </div>
                            <div className='teacher-social-links__wrapper'>
                                <h5 className='teacher-social-links__label'>Tiktok</h5>
                                <input className='teacher-social-links__input' value={tiktok} placeholder="Teacher's Tiktok" onChange={(e) => changeTeacherInfo(e.target.value, setTiktok)}/>
                            </div>
                            <div className='teacher-social-links__wrapper'>
                                <h5 className='teacher-social-links__label'>Personal Website</h5>
                                <input className='teacher-social-links__input' value={personalWebsite} placeholder="Teacher's Website" onChange={(e) => changeTeacherInfo(e.target.value, setPersonalWebsite)}/>
                            </div>
                        </div>
                    </div>
                }
                {tab === 'students' &&
                    <div className='teacher-modal__new-info-box'>
                        <div className="admin-teacher-modal__students-panel">
                            <div className="admin-teacher-modal__students-header">
                                <div>
                                    <div className="admin-teacher-modal__students-kicker">Current Roster</div>
                                    <div className="admin-teacher-modal__students-title">Students assigned to this teacher</div>
                                </div>
                                <div className="admin-teacher-modal__students-count">
                                    {normalizeStudentRoster.length}
                                </div>
                            </div>
                            {normalizeStudentRoster.length === 0 ? (
                                <div className="admin-teacher-modal__students-empty">
                                    No active students are currently assigned to this teacher.
                                </div>
                            ) : (
                                <div className="admin-teacher-modal__students-roster">
                                    <div className="admin-teacher-modal__students-columns">
                                        <div className="admin-teacher-modal__students-column admin-teacher-modal__students-column--name">Student</div>
                                        <div className="admin-teacher-modal__students-column admin-teacher-modal__students-column--family">Family</div>
                                    </div>
                                <div className="admin-teacher-modal__students-list">
                                    {normalizeStudentRoster.map((student) => (
                                        <button
                                            key={student.key}
                                            type="button"
                                            className="admin-teacher-modal__student-row"
                                            onClick={() => openStudentProfile(student.familyId)}
                                        >
                                            <div className="admin-teacher-modal__student-cell admin-teacher-modal__student-cell--name">
                                                <div className="admin-teacher-modal__student-name">{student.studentName}</div>
                                            </div>
                                            <div className="admin-teacher-modal__student-cell admin-teacher-modal__student-cell--family">
                                                <div className="admin-teacher-modal__student-family">
                                                    {student.familyName || '—'}
                                                </div>
                                            </div>
                                        </button>
                                    ))}
                                </div>
                                </div>
                            )}
                        </div>
                    </div>
                }
                {tab === 'waitlist' &&
                    <div className='teacher-modal__new-info-box__waitlist'>
                        {loadingPotentialWaitlist 
                            ? 
                            <div className='teacher-modal__waitlist-empty'>Loading waitlist…</div>
                            :
                            <div className='teacher-modal__waitlist-panel'>
                                <div className='teacher-modal__waitlist-header'>
                                    <div>
                                        <div className='teacher-modal__waitlist-kicker'>Waitlist matches</div>
                                        <div className='teacher-modal__waitlist-title'>Students this teacher could teach</div>
                                        <div className='teacher-modal__waitlist-subtitle'>Sorted by drive time from the teacher’s home</div>
                                    </div>
                                    <div className='teacher-modal__waitlist-count'>{potentialWaitlistStudents.length}</div>
                                </div>
                                {potentialWaitlistError ? <div className='teacher-modal__waitlist-empty is-error'>{potentialWaitlistError}</div> :
                                potentialWaitlistStudents.length === 0 ? <div className='teacher-modal__waitlist-empty'>No matching waitlist or inquiry students</div> :
                                <div className='teacher-modal__waitlist-table-shell'>
                                    <table className='teacher-modal__waitlist-table'>
                                        <colgroup>
                                            <col className='teacher-modal__waitlist-col-student' />
                                            <col className='teacher-modal__waitlist-col-instrument' />
                                            <col className='teacher-modal__waitlist-col-drive' />
                                            <col className='teacher-modal__waitlist-col-status' />
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th>Student</th>
                                                <th>Instrument</th>
                                                <th>Drive time</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {potentialWaitlistStudents.map((student) => (
                                                <tr
                                                    key={student.id}
                                                    className='teacher-modal__waitlist-table__row'
                                                    onClick={() => openStudentProfile(student.familyId)}
                                                >
                                                    <td>
                                                        <div className='teacher-modal__waitlist-student'>{student.studentName}</div>
                                                        <div className='teacher-modal__waitlist-family'>{student.familyName || 'Family name unavailable'}</div>
                                                    </td>
                                                    <td><span className='teacher-modal__waitlist-instrument'>{student.instrument}</span></td>
                                                    <td>
                                                        <span className={Number.isFinite(student.driveTimeMinutes)
                                                            ? 'teacher-modal__waitlist-drive is-ready'
                                                            : 'teacher-modal__waitlist-drive'}>
                                                            {Number.isFinite(student.driveTimeMinutes)
                                                                ? `${student.driveTimeMinutes} min`
                                                                : student.driveTimeStatus}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span className={`teacher-modal__waitlist-status ${student.status === 'Waitlist' ? 'is-waitlist' : 'is-inquired'}`}>
                                                            {student.status}{student.statusScope === 'family' ? ' · Family' : ''}
                                                        </span>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                }
                                {loadingWaitlistDriveTimes && potentialWaitlistStudents.length > 0 && (
                                    <div className='teacher-modal__waitlist-drive-state'>Checking saved drive times…</div>
                                )}
                                {waitlistDriveTimeError && (
                                    <div className='teacher-modal__waitlist-drive-state is-error'>
                                        <span>{waitlistDriveTimeError}</span>
                                        <button
                                            type='button'
                                            onClick={() => loadTeacherWaitlistDriveTimes(potentialWaitlistStudents)}
                                            disabled={loadingWaitlistDriveTimes}
                                        >
                                            Retry drive times
                                        </button>
                                    </div>
                                )}
                            </div>
                        }
                    </div>
                }
                {tab === 'cancellations' &&
                    <div className='teacher-modal__new-info-box'>
                        {
                            listOfCancellations.length > 0 ?
                            listOfCancellations.map((cancellation) => cancellation.total > 0 && (
                                <div className='teacher-modal__cancellation-wrapper' key={cancellation.timesheetDate} onClick={() => openThisTimesheet(cancellation.timesheetId)}>
                                    <div className='teacher-modal__cancelltaion-wrapper__date'>{cancellation.timesheetDate}:</div>
                                    <div className='teacher-modal__cancelltaion-wrapper__number'>{cancellation.total} Cancellation</div>
                                    <div className='teacher-modal__cancelltaion-wrapper__click'>View Timesheet</div>
                                </div>
                            ))
                        :
                            <div>No Cancellations</div>
                        }
                    </div>
                }
                {tab === 'feedback' &&
                <div className='teacher-modal__new-info-box__feedback'>{
                    teacherFeedback.length === 0 ? <div className='teacher-modal__new-info-box'>No Feedback <div onClick={() => setCreateFeedbackLinkModal(true)}  className='teacher-modal__create-teacher-feedback-btn'>Create Teacher Feedback Link</div></div> :
                    teacherFeedback.map((feedback) => (
                        <div className='teacher-modal__family-feedback-card' onClick={() => feedback.id !== openFeedbackCard ? setOpenFeedbackCard(feedback.id) : setOpenFeedbackCard(false)}>
                            <div className='teacher-modal__family-feedback-card__top-section'>
                                <div className='teacher-modal__family-feedback-card__top-section__family-name'>{feedback.familyName}</div>
                                <div className='teacher-modal__family-feedback-card__top-section__right-side'>
                                    <div>
                                        {stars.map((star, index) => (
                                            <svg className="each-star__assessment">
                                                <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                    <g id="star-0" transform="translate(-385.000000, -931.000000)" fill={index < feedback.starRating ? "#FBBF24" : "rgb(200, 200, 200)"}>
                                                        <polygon id="Star-Copy" points="401.5 953.839042 391.801543 960.84878 395.471213 949.458872 385.807567 942.40122 397.774005 942.371608 401.5 931 405.225995 942.371608 417.192433 942.40122 407.528787 949.458872 411.198457 960.84878"></polygon>
                                                    </g>
                                                </g>
                                            </svg>
                                        ))}
                                    </div>
                                    <MdExpandMore className='teacher-modal__family-feedback-card__expand' size={24} color='#94A3B8' />
                                </div>
                            </div>
                            {openFeedbackCard === feedback.id && <div>
                                <div className='teacher-modal__family-feedback-card_each-section'>
                                    <div className='teacher-modal__family-feedback-card_each-section__label'>Highlights</div>
                                    <div className='teacher-modal__family-feedback-card_each-section__content'>{feedback.teacherHighlights}</div>
                                </div>
                                <div className='teacher-modal__family-feedback-card_each-section'>
                                    <div className='teacher-modal__family-feedback-card_each-section__label'>Favorite Thing</div>
                                    <div className='teacher-modal__family-feedback-card_each-section__content'>{feedback.teacherFavorites}</div>
                                </div>
                                </div>
                            }
                        </div>
                    ))}
                <div onClick={() => setCreateFeedbackLinkModal(true)}  className='teacher-modal__create-teacher-feedback-btn'>Create Teacher Feedback Link</div>
                </div>

                }
                {tab === 'map' &&
                    <div className='teacher-modal__new-info-box'>
                        <div style={{width: '625px', height: '400px'}}>
                            <APIProvider apiKey={'AIzaSyDKCEsq1kPacCY7j2S78YOskPLApGtK3jQ'}>
                                <GoogleMap
                                    zoom={10}
                                    center={mapCenter}
                                    gestureHandling={'greedy'}
                                    disableDefaultUI={true}
                                    mapId={'3324feda48bc0f19'}
                                >
                                    <CustomMarkers points={validGeoLocations} />
                                </GoogleMap>
                            </APIProvider>
                        </div>
                    </div>
                }
                <div className='reset-teacher-pass-btn' onClick={() => resetPasswordToPassword()}>Reset Password</div>
                <div className="delete-teacher-btn" onClick={() => setDeleteModal(true)}>Delete Teacher</div>
            </div>
        </div>
    )
}

export default AdminTeacherModal
